<template>
    <div>
        <button class="d-none" @click="openPostModal()" id="openFormPlanningModal">new</button>

        <div class="modal fade" id="postPlanningModal" tabindex="-1" aria-labelledby="postPlanningModal" aria-hidden="true">
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ form.id == null ? 'Nouvelle' : 'Modification de la' }} planification</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <i class="fal fa-times"></i>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-sm-12">
                                <div class="form-group">
                                    <label for="identityAutocomplete">Salarié</label>
                                    <div class="ix-table-box">
                                        <table class="ix-table">
                                            <tbody>
                                                <tr v-if="users.length == 0">
                                                    <td colspan="100%">Aucun salarié sélectionné</td>
                                                </tr>
                                                <tr v-for="(user, index) in users" :key="index">
                                                    <td>
                                                        <span class="ix-avatar xsm">
                                                            <img :src="user.avatar_path" v-if="user.avatar_path">
                                                            <span v-if="!user.avatar_path">{{ user.initial }}</span>
                                                        </span>
                                                        {{ user.fullname }}
                                                        <input type="hidden" :name="'users[' + index + '][id]'"
                                                            v-model="user.id">
                                                        <input type="hidden" :name="'users[' + index + '][fullname]'"
                                                            v-model="user.fullname">
                                                        <input type="hidden" :name="'users[' + index + '][avatar_path]'"
                                                            v-model="user.avatar_path">
                                                        <input type="hidden" :name="'users[' + index + '][initial]'"
                                                            v-model="user.initial">
                                                    </td>
                                                    <td class="text-right">
                                                        <button type="button" class="btn btn-sm transparent"
                                                            @click="deleteUserRow(index)">
                                                            <i class="far fa-trash"></i>
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td colspan="100%">
                                                        <input
                                                            placeholder="Commencer la saisie pour obtenir des suggestions .."
                                                            class="form-control" id="userSearchInput" type="text"
                                                            v-model="user">
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                            <div class="col-sm-12 col-md-6">
                                <div class="form-group">
                                    <label for="start_at" class="required">Du :</label>
                                    <v-date-picker v-model="form.start_at" :max-date="maxStartDate" mode="datetime"
                                        :timezone="timezone" is24hr :popover="{ visibility: 'click' }">
                                        <template v-slot="{ inputValue, inputEvents }">
                                            <input class="form-control" :value="inputValue" v-on="inputEvents"
                                                required="true" name="start_at" id="start_at" />
                                        </template>
                                    </v-date-picker>
                                </div>
                            </div>

                            <div class="col-sm-12 col-md-6">
                                <div class="form-group">
                                    <label for="end_at" class="required">Au : </label>
                                    <v-date-picker v-model="form.end_at" :min-date="minEndDate" mode="datetime"
                                        :timezone="timezone" is24hr :popover="{ visibility: 'click' }">
                                        <template v-slot="{ inputValue, inputEvents }">
                                            <input class="form-control" :value="inputValue" v-on="inputEvents"
                                                required="true" name="end_at" id="end_at" />
                                        </template>
                                    </v-date-picker>
                                </div>
                            </div>


                        </div>
                    </div>

                    <div class="modal-footer">
                        <button type="submit" class="ix-btn green" v-bind:disabled="!checkForm() || loadingForm"
                            @click="post()">
                            <span v-if="!loadingForm">Enregistrer</span>
                            <span v-if="loadingForm"><i class="far fa-circle-notch fa-spin"></i></span>
                        </button>
                    </div>
                </div>


            </div>
        </div>
    </div>
</template>

<script>

import $ from "jquery";
import axios from 'axios';

export default {
    name: "FormPlanningComponent",
    props: ['url', 'usersUrl', 'inspectionProps'],
    data() {
        return {
            loading: true,
            loadingForm: false,
            loadingShow: false,
            loadingDelete: false,
            form: this.fillForm(),
            timezone: '',
            minDate: null,
            users: [],
            user: null,
            inspection: null,
            inspections: [],
            table: {
                days: [],
                weeks: [],
                months: [],
                data: []
            },
            selectedInspection: null,
            message: 'success',
        }
    },
    computed: {
        minEndDate() {
            if (this.form.start_at) {
                const minDate = new Date(this.form.start_at);
                minDate.setHours(minDate.getHours() + 1);
                return minDate.toISOString();
            }
        },
        maxStartDate() {
            if (this.form.end_at) {
                const maxDate = new Date(this.form.end_at);
                maxDate.setHours(maxDate.getHours() + 1);
                return maxDate.toISOString();
            }
        }
    },
    methods: {
        fillForm(planning = null) {
            this.users = planning ? planning.users : [];

            return {
                id: planning ? planning.id : null,
                description: planning ? planning.description : '',
                start_at: planning ? this.moment(planning.start_at).format() : null,
                end_at: planning ? this.moment(planning.end_at).format() : null,
            }
        },
        openPostModal() {
            this.form = this.fillForm(null)
            $('#postPlanningModal').modal()
        },
        checkForm() {
            return this.form.start_at && this.form.end_at && this.users.length > 0 && this.inspections.length > 0;
        },
        // Users
        addUserRow: function (user) {
            if (this.getCurrentSelectedUsersId().includes(user.id) == false) {
                this.users.push(user)
            }
        },
        deleteUserRow: function (index) {
            this.users.splice(index, 1)
        },

        getCurrentSelectedUsersId: function () {
            return this.users.map(user => user.id);
        },
        async post() {
            this.loadingForm = true

            var data = {
                start_at: this.moment(this.form.start_at).format('L LT'),
                end_at: this.moment(this.form.end_at).format('L LT'),
                users: this.users,
                inspections: this.inspections,
            }

            fetch(this.url + (this.form.id ? '/' + this.form.id : ''), {
                ...this.getHttpJsonRequestHeaders(),
                ...{
                    method: this.form.id ? "PUT" : "POST",
                    body: JSON.stringify(data)
                }
            }).then((response) => {
                if (response.ok) {
                    response.json().then((data) => {
                        location.reload();
                    })
                }
            }).catch((error) => {
                console.log(error);
            });
        },
    },
    async mounted() {
        this.inspections.push(JSON.parse(this.inspectionProps))
        $("#userSearchInput").autocomplete({
            minLength: 0,
            source: (request, response) => {
                $.ajax({
                    url: this.usersUrl,
                    type: 'get',
                    dataType: 'json',
                    headers: this.getHttpJsonRequestHeaders().headers,
                    data: { q: request.term, '!id': this.getCurrentSelectedUsersId().join(';'), 'under_contract': 1 },
                    success: (data) => {
                        response($.map(data, (item) => {
                            return Object.assign(item, {
                                label: item.fullname,
                                value: item.fullname
                            })
                        }))
                    }
                });
            },
            change: (e, item) => {
                if (!item.item) {
                    $(e.target).val("");
                    this.user = null
                }
            },
            select: (e, item) => {
                if (item.item) {
                    this.addUserRow(item.item)
                    $(e.target).val("")
                    this.user = null
                }
            }
        }).focus(() => {
            $("#userSearchInput").autocomplete("search", '');
        });

    }
};

</script>